import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexa';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../../components/Typography';
import PricingPlanBuy from './subcomponents/PricingPlan/PricingPlanBuy';
import CallUs from './CallUs';
import { membershipOffers } from '../api/membership';
import { getPenguinsData } from '../../helpers';

const styles = theme => ({
  root: {
    maxWidth: 1343,
    textAlign: 'center',
    margin: '0 auto',
    padding: '5% 0',
    [theme.breakpoints.down('md')]: {
      margin: '20px 1em'
    }
  },
  headline: {
    fontSize: '3.5rem',
    [theme.breakpoints.down('340')]: {
      fontSize: '1rem'
    }
  },
  pricingBenefitsContainer: {
    textAlign: 'center',
    maxWidth: 900,
    margin: '0 auto',
    marginBottom: '5%'
  },
  intro: {
    marginTop: '5%',
    marginBottom: '5%',
    [theme.breakpoints.down('351')]: {
      marginBottom: '10%'
    }
  }
});

class PricingPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plans: [
        {
          type: 'monthly',
          typeId: '15',
          monthlyPrice: '44.99',
          installmentPrice: '44.99',
          initiationPrice: '499',
          trackingId: '531393',
          savings: null,
          highlight: false
        },
        {
          type: 'yearly',
          typeId: '46',
          monthlyPrice: '24.99',
          installmentPrice: '299.88',
          initiationPrice: '499',
          trackingId: '531393',
          savings: '23',
          highlight: true
        }
      ]
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const { tracking_id, country_id } = getPenguinsData('view_data');
      membershipOffers(tracking_id, country_id).then(res => {
        this.setState({ plans: this.parsePlanInfo(res.data) });
      });
    }
  }

  parsePlanInfo = data => {
    let plans = data.types.map(x => {
      return {
        trackingId: x.tracking_id,
        description: x.description,
        typeId: x.type_id,
        initiationPrice: x.initiation_fee,
        installmentPrice: x.renewal_fee,
        monthlyPrice:
          x.term === 12
            ? x.renewal_fee
            : (parseFloat(x.renewal_fee) / 12).toFixed(2),
        type: x.term === 12 ? 'monthly' : 'yearly',
        term: x.term,
        totalPrice:
          x.term * parseFloat(x.renewal_fee) + parseFloat(x.initiation_fee)
      };
    });

    const maxPrice = Math.max(...plans.map(x => x.totalPrice));
    const minPrice = Math.min(...plans.map(x => x.totalPrice));
    plans = plans.map((x, index) => {
      x.savings = null;
      x.highlight = false;
      if (x.totalPrice < maxPrice) {
        x.savings = (100 * (maxPrice - x.totalPrice)) / maxPrice;
        x.savings = x.savings.toFixed(0);
      }
      if (x.totalPrice === minPrice && index !== 0) {
        x.highlight = true;
      }
      return x;
    });
    return plans;
  };

  render() {
    const { classes, locRef } = this.props;
    const { plans } = this.state;
    const offset = (12 - 4 * plans.length) / 2;
    return (
      <div className={classes.root} ref={locRef}>
        <Typography
          className={classes.headline}
          variant="subtitle1"
          color="primary"
          bold
          upper
        >
          Becoming A Member Is Easy
        </Typography>
        <Typography variant="h2" bold>
          Choose Your Pricing Plan
        </Typography>
        <Typography variant="body1" color="secondary" upper>
          30 Day Money Back Guarantee
        </Typography>
        <Row gutter={0} style={{ margin: '0 auto', paddingTop: '1rem' }}>
          {offset ? <Col xs={0} sm={0} md={0} lg={offset} /> : ''}
          {plans.map((plan, index) => {
            const {
              type,
              typeId,
              monthlyPrice,
              installmentPrice,
              initiationPrice,
              trackingId,
              savings,
              highlight
            } = plan;
            return (
              <PricingPlanBuy
                key={index}
                type={type}
                typeId={typeId}
                monthlyPrice={monthlyPrice}
                installmentPrice={installmentPrice}
                initiationPrice={initiationPrice}
                trackingId={trackingId}
                savings={savings}
                highlight={highlight}
              />
            );
          })}
          {offset ? <Col xs={0} sm={0} md={0} lg={offset} /> : ''}
        </Row>
        <div className={classes.pricingBenefitsContainer}>
          <Typography
            className={classes.intro}
            variant="body1"
            color="secondary.dark"
          >
            {
              'Enjoy access to the entire line of our vendor’s products at the DirectBuy price. With DirectBuy Concierge service, members have access to hundreds of thousands of products at prices below retail!'
            }
          </Typography>
        </div>
        <CallUs primary />
      </div>
    );
  }
}

PricingPlan.propTypes = {
  classes: PropTypes.object.isRequired,
  locRef: PropTypes.object.isRequired
};

export default withStyles(styles)(PricingPlan);
